import { type ReactNode } from "react";

export const MobileContent = ({ children }: { children: ReactNode }) => (
  <main
    className="max-w-screen-xl mx-auto px-4 min-h-screen overflow-y-auto"
    style={{ paddingTop: "calc(4.5rem + var(--ldf-top))", paddingBottom: "calc(5rem + env(safe-area-inset-bottom))" }}
    id="main-content"
  >
    {children}
  </main>
);
